<template>
  <div class="max-w-screen-lg mx-auto p-4">
    <slot />
  </div>
</template>
